import React from "react";
import { connect } from "react-redux";
import {
  changeStep,
  changeData,
  saveRegistration,
  registrationConfirmed,
  addReferer,
  addAffiliate,
  getConversion
} from "../../../actions";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import {
  Step,
  StepLabel,
  StepContent,
  Container,
  Typography,
  Stepper,
  Button
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import WalletAddressForm from "../WalletAddressForm";
//import PlannedInvestmentForm from "../PlannedInvestmentForm";
import InvestmentForm from "../InvestmentForm";
import RegistrationForm from "../RegistrationForm";
import ConfirmForm from "../ConfirmForm";
import Finished from "../Finished/index";
import Spinner from "../../atoms/Spinner";

// import { withGTM } from "react-tag-manager";
import { Link } from "react-router-dom";

const styles = theme => ({
  root: {
    width: "100%"
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  actionsContainer: {
    marginBottom: theme.spacing(2)
  },
  resetContainer: {
    padding: theme.spacing(3)
  },
  header: {
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }
});

const mapStateToProps = state => {
  return {
    activeStep: state.activeStep,
    state
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeStep: step => dispatch(changeStep(step)),
    changeData: (section, data) => dispatch(changeData(section, data)),
    saveRegistration: part => dispatch(saveRegistration(part)),
    registrationConfirmed: () => dispatch(registrationConfirmed()),
    addReferer: data => dispatch(addReferer(data)),
    addAffiliate: data => dispatch(addAffiliate(data)),
    getConversion: () => dispatch(getConversion())
  };
};

function getSteps(showOrder) {
  if (showOrder) {
    return [
      "Your Order",
      "Personal Information",
      "Enter Wallet Address",
      "Confirm"
    ];
  } else {
    return ["Personal Information", "Enter Wallet Address", "Confirm"];
  }
}

class RVerticalLinearStepper extends React.Component {
  constructor(props) {
    super();
    if (window.localStorage) {
      const ld = localStorage.getItem("conda_utm");
      if (ld !== null) {
        try {
          const utm = JSON.parse(ld);
          let data = {};
          if (utm.hasOwnProperty("utm_media")) {
            data["utm_media"] = utm.utm_media;
          }
          if (utm.hasOwnProperty("utm_campaign")) {
            data["utm_campaign"] = utm.utm_campaign;
          }
          if (utm.hasOwnProperty("utm_source")) {
            data["utm_source"] = utm.utm_source;
          }
          if (utm.hasOwnProperty("createdat")) {
            data["createdat"] = utm.createdat;
          }
          props.addReferer(data);
        } catch (e) {}
      }
      const lda = localStorage.getItem("AFFID");
      if (lda !== null) {
        try {
          const aff = JSON.parse(lda);
          let data = {};
          if (aff.hasOwnProperty("id")) {
            data["id"] = aff.id;
          }
          if (aff.hasOwnProperty("createdat")) {
            data["createdat"] = aff.createdat;
          }
          props.addAffiliate(data);
        } catch (e) {}
      }
    }
    this.handleSave = this.handleSave.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    console.log("process.env.REACT_APP_STATUS" + process.env.REACT_APP_STATUS);
    this.showOrder =
      props.match.path === "/order" && process.env.REACT_APP_STATUS !== "PAUSE";
  }
  componentDidMount() {
    this.props.getConversion();
    this.triggerGTMEvent(this.props.activeStep);
  }
  handleSave(data) {
    this.props.changeData(data.section, data.data);
  }
  handleNext(data = null) {
    const nextStep = this.props.activeStep + 1;
    if (nextStep === getSteps(this.showOrder).length) {
      this.props.registrationConfirmed();
      this.props.saveRegistration("frontside");
      this.props.saveRegistration("backside");
      this.props.saveRegistration("selfi");
    } else {
      this.props.changeStep(nextStep);
    }
    this.triggerGTMEvent(nextStep);
  }

  handleBack() {
    this.triggerGTMEvent(this.props.activeStep - 1);
    this.props.changeStep(this.props.activeStep - 1);
  }

  triggerGTMEvent(step = 0) {
    // const { GTM } = this.props;
    // let path;
    // if (this.showOrder) {
    //   path = [
    //     "/i/registration/order",
    //     "/i/registration/personalinformation",
    //     "/i/registration/walletaddress",
    //     "/i/registration/confirmation",
    //     "/i/registration/finished"
    //   ];
    // } else {
    //   path = [
    //     "/i/registration/personalinformation",
    //     "/i/registration/walletaddress",
    //     "/i/registration/confirmation",
    //     "/i/registration/finished"
    //   ];
    // }
    // GTM.api.trigger({
    //   event: "pageViewProcess",
    //   path: path[step]
    // });
  }

  getStepContent(step) {
    const maxSteps = getSteps(this.showOrder).length;
    if (this.showOrder) {
      switch (step) {
        case 0:
          return (
            <div>
              <InvestmentForm
                step={step}
                maxsteps={maxSteps}
                save={this.handleSave}
                next={this.handleNext}
                back={this.handleBack}
                data={this.props.state.order}
                reload={this.props.getConversion}
              />
            </div>
          );
        case 1:
          return (
            <div>
              <RegistrationForm
                step={step}
                maxsteps={maxSteps}
                save={this.handleSave}
                next={this.handleNext}
                back={this.handleBack}
                data={{
                  personal_information: this.props.state.personal_information,
                  confirmation: this.props.state.confirmation,
                  document: this.props.state.document
                }}
              />
            </div>
          );
        case 2:
          return (
            <div>
              <WalletAddressForm
                step={step}
                maxsteps={maxSteps}
                save={this.handleSave}
                next={this.handleNext}
                back={this.handleBack}
                data={this.props.state}
              />
            </div>
          );
        case 3:
          return (
            <div>
              <ConfirmForm
                step={step}
                maxsteps={maxSteps}
                save={this.handleSave}
                back={this.handleBack}
                next={this.handleNext}
                data={this.props.state}
              />
            </div>
          );
        default:
          return "Unknown step";
      }
    } else {
      switch (step) {
        case 0:
          return (
            <div>
              <RegistrationForm
                step={step}
                maxsteps={maxSteps}
                save={this.handleSave}
                next={this.handleNext}
                back={this.handleBack}
                data={{
                  personal_information: this.props.state.personal_information,
                  confirmation: this.props.state.confirmation,
                  document: this.props.state.document
                }}
              />
            </div>
          );
        case 1:
          return (
            <div>
              <WalletAddressForm
                step={step}
                maxsteps={maxSteps}
                save={this.handleSave}
                next={this.handleNext}
                back={this.handleBack}
                data={this.props.state}
              />
            </div>
          );
        case 2:
          return (
            <div>
              <ConfirmForm
                step={step}
                maxsteps={maxSteps}
                save={this.handleSave}
                back={this.handleBack}
                next={this.handleNext}
                data={this.props.state}
              />
            </div>
          );
        default:
          return "Unknown step";
      }
    }
  }

  renderSavingsError() {
    const { SavingError, SavingErrorCounter } = this.props.state;
    if (SavingError && SavingErrorCounter > 0) {
      return (
        <Paper square elevation={0} style={{ padding: "2em" }}>
          {SavingError.frontside && (
            <Typography style={{ color: "red" }}>
              <b>Error:</b>{" "}
              {`Document frontside image could not be saved. (${SavingError.frontside.display.status}) `}
            </Typography>
          )}
          {SavingError.backside && (
            <Typography style={{ color: "red" }}>
              <b>Error:</b>{" "}
              {`Document backside image could not be saved. (${SavingError.backside.display.status})`}
            </Typography>
          )}
          {SavingError.selfi && (
            <Typography style={{ color: "red" }}>
              <b>Error:</b>{" "}
              {`Document selfi image could not be saved. (${SavingError.selfi.display.status})`}
            </Typography>
          )}
          <Typography style={{ marginTop: "1em" }}>
            Please check your network connection. Your entered data is stored in
            your browser until you close this window. Please try again or
            contact{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="mailto:team@crwdnetwork.com"
            >
              team@crwdnetwork.com
            </a>{" "}
            .
          </Typography>
          <div style={{ marginTop: "1em" }} align="center">
            <Button
              onClick={this.handleNext}
              color="primary"
              type="button"
              variant="outlined"
            >
              retry
            </Button>
          </div>
        </Paper>
      );
    } else {
      return null;
    }
  }

  renderSavingSpinner() {
    if (
      this.props.state.saveCounter > 0 &&
      this.props.state.SavingErrorCounter === 0
    )
      return (
        <Paper square elevation={0} align="center">
          <div style={{ height: "100px" }}>
            <Spinner />
          </div>
          <Typography variant="h5" style={{ marginBottom: "3em" }}>
            Saving {this.props.state.saveCounter} images...
          </Typography>
        </Paper>
      );
  }

  render() {
    const { classes, activeStep } = this.props;
    const steps = getSteps(this.showOrder);
    //const { activeStep } = this.state;

    return (
      <div className={classes.root}>
        <Container>
          {this.showOrder && (
            <Paper square elevation={0} className={classes.header}>
              <Typography variant="h3" align="center">
                Buy CRWDToken
              </Typography>
              <Typography variant="h3" align="center" gutterBottom>
                <strong>Registration and Whitelisting</strong>
              </Typography>
              <Typography align="center">
                Follow these steps to join our token sale. If you have an
                account{" "}
                <Link to="/dashboard/order"> sign up to place your order</Link>.
              </Typography>
            </Paper>
          )}
          {!this.showOrder && (
            <Paper square elevation={0} className={classes.header}>
              <Typography variant="h3" align="center">
                Whitelisting for
              </Typography>
              <Typography variant="h3" align="center" gutterBottom>
                <strong>
                  {process.env.REACT_APP_STATUS !== "PAUSE"
                    ? "Pre-Sale and Crowd-Sale"
                    : "Crowd-Sale"}
                </strong>
              </Typography>
              <Typography>
                Follow these steps to join our token sale whitelisting. You will
                need to be whitelisted in order to participate in our{" "}
                <a href="/icoinfo/" target="_blank" rel="noopener noreferrer">
                  {process.env.REACT_APP_STATUS !== "PAUSE"
                    ? "Pre-Sale and Crowd-Sale"
                    : "Crowd-Sale"}
                </a>
                .
              </Typography>
            </Paper>
          )}
          {activeStep !== steps.length &&
            this.props.state.saveCounter === 0 &&
            this.props.state.SavingErrorCounter === 0 && (
              <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((label, index) => {
                  return (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                      <StepContent>{this.getStepContent(index)}</StepContent>
                    </Step>
                  );
                })}
              </Stepper>
            )}
          {this.renderSavingSpinner()}
          {this.renderSavingsError()}
          {activeStep === steps.length && (
            <Paper square elevation={0} className={classes.resetContainer}>
              <Finished />
            </Paper>
          )}
        </Container>
      </div>
    );
  }
}

RVerticalLinearStepper.propTypes = {
  classes: PropTypes.object
};

const VerticalLinearStepper = connect(
  mapStateToProps,
  mapDispatchToProps
)(RVerticalLinearStepper);

// const gtmVerticalLinearStepper = withGTM(VerticalLinearStepper);
const gtmVerticalLinearStepper = VerticalLinearStepper;

export default withStyles(styles)(gtmVerticalLinearStepper);
